export enum TableExport {
  'inactivas' = 'Inactivas',
  'activas' = 'Activas',
  'orderstatus' = 'Estado de Ordenes',
}
